// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"375":"035ce7ba","542":"58772b40","692":"035ce7ba","794":"a59d71c7","977":"5efc0f1e"}[chunkId] + ".chunk.css";
};